import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeRouter from './module/homeRouter' //主页模块路由
import enterpriseRouter from './module/enterpriseRouter' //企业模块路由
import contractRouter from './module/contractRouter' //合同模块路由
import userRouter from './module/userRouter' //用户模块路由



Vue.use(VueRouter)

const createRouter = () => new VueRouter({
	scrollBehavior: () => ({
		y: 0
	}),
	//mode: 'history',
	routes: [
		...HomeRouter,
		...enterpriseRouter,
		...contractRouter,
		...userRouter
	]
});

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	console.log('执行')
	console.log(router)
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
	console.log('完成')
	console.log(newRouter)
}

// const router = new VueRouter({
// 	routes: [
// 		...HomeRouter,
// 		...HandleRouter,
// 		...enterpriseRouter,
// 		...contractRouter,
// 		...userRouter
// 	]
// });


export default router